


function addAltText_eb0d5475c1cf489c8fca36a0bd863188() {
  const altTextMap = {"td-modal[data-id=\"item_QYrPrb\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img":{"selector":"td-modal[data-id=\"item_QYrPrb\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img","alt":"Woman in a pink bikini top with a towel on her head, holding a product tube and smiling, with text 'Go-to air dry routine for perfect beach day waves'."},"td-modal[data-id=\"item_NjBbhR\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img":{"selector":"td-modal[data-id=\"item_NjBbhR\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img","alt":"Man in a light sweater adjusting his hair, looking to the side."},"td-modal[data-id=\"item_9DcaQF\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img":{"selector":"td-modal[data-id=\"item_9DcaQF\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img","alt":"Man with tousled hair and a beard, wearing a gray shirt, looking at the camera."},"td-modal[data-id=\"item_khjL8f\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img":{"selector":"td-modal[data-id=\"item_khjL8f\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img","alt":"Woman with tattoos and green nail polish pointing to her forehead, wearing a white top."},"td-modal[data-id=\"item_aDPfJz\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img":{"selector":"td-modal[data-id=\"item_aDPfJz\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img","alt":"Woman with a slicked-back ponytail, wearing a floral dress with an open back, with text 'How to: Slicked-Back Pony'."},"td-modal[data-id=\"item_WiUqQ9\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img":{"selector":"td-modal[data-id=\"item_WiUqQ9\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img","alt":"Man with curly hair pointing to his hair, with text 'Curly hair problems fixed with only one natural product...'."},".custom-row-icon:nth-child(5) > .raw-icon-image > .icon-img > img":{"selector":".custom-row-icon:nth-child(5) > .raw-icon-image > .icon-img > img","alt":"Icon of an award ribbon with a star in the center, in a dark circle."},".custom-row-icon:nth-child(1) > .raw-icon-image > .icon-img > img":{"selector":".custom-row-icon:nth-child(1) > .raw-icon-image > .icon-img > img","alt":"Icon of a leaf and a mortar and pestle, representing plant-based products, in a dark circle."},".custom-row-icon:nth-child(6) > .raw-icon-image > .icon-img > img":{"selector":".custom-row-icon:nth-child(6) > .raw-icon-image > .icon-img > img","alt":"Icon of a clock showing 24 hours, in a dark circle."},".custom-row-icon:nth-child(3) > .raw-icon-image > .icon-img > img":{"selector":".custom-row-icon:nth-child(3) > .raw-icon-image > .icon-img > img","alt":"Icon of a chemical flask with a diagonal line through it, representing chemical-free products, in a dark circle."},".custom-row-icon:nth-child(2) > .raw-icon-image > .icon-img > img":{"selector":".custom-row-icon:nth-child(2) > .raw-icon-image > .icon-img > img","alt":"Eco-friendly icon with a box and two leaves"},".custom-row-icon:nth-child(4) > .raw-icon-image > .icon-img > img":{"selector":".custom-row-icon:nth-child(4) > .raw-icon-image > .icon-img > img","alt":"Hydrating icon with a water droplet and a curved line"},"a[href$=\"glacial-cream\"] > .large-hide[width=\"\"][height=\"\"]":{"selector":"a[href$=\"glacial-cream\"] > .large-hide[width=\"\"][height=\"\"]","alt":"Person holding a tube of Highland Glacial Cactus Cream"},"a[href$=\"glacial-clay-pomade\"] > .large-hide[width=\"\"][height=\"\"]":{"selector":"a[href$=\"glacial-clay-pomade\"] > .large-hide[width=\"\"][height=\"\"]","alt":"Person holding a tin of Highland Glacial Clay Pomade"}};

  function traverseSpecificElement(root, selector, callback) {
    if (selector.includes('>>>')) {
      // Shadow DOM traversal
      const [shadowHost, innerSelector] = selector.split('>>>').map(s => s.trim());
      const hostElement = root.querySelector(shadowHost);
      if (hostElement && hostElement.shadowRoot) {
        hostElement.shadowRoot.querySelectorAll(innerSelector).forEach(callback);
      }
    } else if (selector.includes('>>')) {
      // iframe traversal
      const [iframeSelector, innerSelector] = selector.split('>>').map(s => s.trim());
      const iframe = root.querySelector(iframeSelector);
      if (iframe && iframe.contentDocument) {
        iframe.contentDocument.querySelectorAll(innerSelector).forEach(callback);
      }
    } else {
      // Regular DOM traversal
      root.querySelectorAll(selector).forEach(callback);
    }
  }

  Object.entries(altTextMap).forEach(([key, value]) => {
    const { selector, alt } = value;

    // CSS selector
    traverseSpecificElement(document, selector, (img) => {
      if (img instanceof HTMLImageElement && (!img.alt || img.alt === "")) {
        img.alt = alt;
        img.setAttribute('data-alt-added', 'eb0d5475c1cf489c8fca36a0bd863188');
      }
    });
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addAltText_eb0d5475c1cf489c8fca36a0bd863188);
} else {
  addAltText_eb0d5475c1cf489c8fca36a0bd863188();
}

// Rerun the function when the DOM changes
const observer_eb0d5475c1cf489c8fca36a0bd863188 = new MutationObserver(() => {
  addAltText_eb0d5475c1cf489c8fca36a0bd863188();
});
observer_eb0d5475c1cf489c8fca36a0bd863188.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_4ec7b0717033407e9352a6136bcde212() {
    const interval = setInterval(() => {
        try {
            const iframe = document.querySelector('#landing_iframe');
            if (iframe) {
                const hasTitle = iframe.hasAttribute('title');
                const ariaLabel = iframe.getAttribute('aria-label');
                const ariaLabelledBy = iframe.getAttribute('aria-labelledby');
                const role = iframe.getAttribute('role');
                const ariaLabelledByElement = ariaLabelledBy ? document.getElementById(ariaLabelledBy) : null;
                const ariaLabelledByContent = ariaLabelledByElement ? ariaLabelledByElement.textContent.trim() : '';

                if (!hasTitle && (!ariaLabel || ariaLabel.trim() === '') && (!ariaLabelledBy || !ariaLabelledByElement || ariaLabelledByContent === '') && (!role || (role !== 'none' && role !== 'presentation'))) {
                    iframe.setAttribute('title', 'Embedded content');
                    iframe.setAttribute('data-accessibility-fix', '4ec7b0717033407e9352a6136bcde212');
                    clearInterval(interval);
                }
            }
        } catch (error) {
            console.error('Error fixing accessibility issue:', error);
        }
    }, 1000);
}

fixAccessibility_4ec7b0717033407e9352a6136bcde212();


function addAltText_34a14895750c47d2a53b07de31c24729() {
  const altTextMap = [["td-modal[data-id=\"item_pBfLp6\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img",{"selector":"td-modal[data-id=\"item_pBfLp6\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img","alt":"Person with curly hair adjusting their hair in a room with plants and framed art on the wall."}],["li[aria-label=\"3 / 6\"] > video > img",{"selector":"li[aria-label=\"3 / 6\"] > video > img","alt":"Person with messy hair and a beard wearing a t-shirt, standing indoors."}],[".swiper-slide-visible > video > img",{"selector":".swiper-slide-visible > video > img","alt":"Person in a denim jacket standing against a patterned wall."}],["li[aria-label=\"5 / 6\"] > video > img",{"selector":"li[aria-label=\"5 / 6\"] > video > img","alt":"Open tin of Highland after shave on a dark surface."}],["li[aria-label=\"2 / 6\"] > video > img",{"selector":"li[aria-label=\"2 / 6\"] > video > img","alt":"Text 'HIGHLAND' on a plain gray background."}],["li[aria-label=\"6 / 6\"] > video > img",{"selector":"li[aria-label=\"6 / 6\"] > video > img","alt":"Multiple tins of Highland product with a compass design on grass."}],["li[aria-label=\"4 / 6\"] > video > img",{"selector":"li[aria-label=\"4 / 6\"] > video > img","alt":"Person with long blonde hair styled in a sleek ponytail, wearing a floral dress."}]];
  const selectorRouteMap = {"td-modal[data-id=\"item_pBfLp6\"] > .td-ugc-slider__card[data-icon-modal-trigger=\"\"] > video[muted=\"muted\"][playsinline=\"true\"] > img":["https://www.highland.style/"],"li[aria-label=\"3 / 6\"] > video > img":["https://www.highland.style/products/glacial-clay-pomade"],".swiper-slide-visible > video > img":["https://www.highland.style/products/glacial-clay-pomade"],"li[aria-label=\"5 / 6\"] > video > img":["https://www.highland.style/products/glacial-clay-pomade"],"li[aria-label=\"2 / 6\"] > video > img":["https://www.highland.style/products/glacial-clay-pomade"],"li[aria-label=\"6 / 6\"] > video > img":["https://www.highland.style/products/glacial-clay-pomade"],"li[aria-label=\"4 / 6\"] > video > img":["https://www.highland.style/products/glacial-clay-pomade"]};

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split('>>').map(s => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter(el => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
    const currentPath = window.location.origin + window.location.pathname;
    return routes.some(route => {
      const routeRegex = new RegExp('^' + route.replace(/\*/g, '.*') + '$');
      return routeRegex.test(currentPath);
    });
  }

  altTextMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (img) => {
        if ((img instanceof HTMLImageElement || img instanceof SVGElement) && (!img.alt || img.alt === "")) {
          
          img.alt = value.alt;
          
          img.setAttribute('data-alt-added', '34a14895750c47d2a53b07de31c24729');
        }
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addAltText_34a14895750c47d2a53b07de31c24729);
} else {
  addAltText_34a14895750c47d2a53b07de31c24729();
}

// Rerun the function when the DOM changes
const observer_34a14895750c47d2a53b07de31c24729 = new MutationObserver(() => {
  addAltText_34a14895750c47d2a53b07de31c24729();
});
observer_34a14895750c47d2a53b07de31c24729.observe(document.body, { childList: true, subtree: true });

function fixAccessibility_085f1caec8fd4983bd77328486876fa5() {
    const intervalId = setInterval(() => {
        try {
            const iframe = document.querySelector('#mcforms-875-1590');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ action: 'checkAccessibilityFix' }, '*');
            }

            window.addEventListener('message', function(event) {
                if (event.data.action === 'applyAccessibilityFix') {
                    const formElement = iframe.contentDocument.querySelector('.step.visible[role="dialog"]');
                    if (formElement) {
                        formElement.removeAttribute('role');
                        formElement.removeAttribute('aria-modal');
                        formElement.setAttribute('data-accessibility-fix', '085f1caec8fd4983bd77328486876fa5');
                        clearInterval(intervalId);
                        console.log('Accessibility fix applied successfully.');
                    }
                }
            });
        } catch (error) {
            console.error('An error occurred while applying the accessibility fix:', error);
        }
    }, 1000);
}

fixAccessibility_085f1caec8fd4983bd77328486876fa5();

function fixAccessibility_88b57996a39043bba6cde81a9aae88f8() {
    const interval = setInterval(() => {
        try {
            const headings = document.querySelectorAll('.rte > h2');
            let allFixed = true;

            headings.forEach(heading => {
                if (heading.textContent.trim() === '' && !heading.hasAttribute('data-accessibility-fix')) {
                    heading.setAttribute('aria-hidden', 'true');
                    heading.setAttribute('data-accessibility-fix', '88b57996a39043bba6cde81a9aae88f8');
                    allFixed = false;
                }
            });

            // Check for iframes and communicate via postMessage
            const iframes = document.querySelectorAll('iframe');
            iframes.forEach(iframe => {
                try {
                    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                    const iframeHeadings = iframeDocument.querySelectorAll('.rte > h2');

                    iframeHeadings.forEach(heading => {
                        if (heading.textContent.trim() === '' && !heading.hasAttribute('data-accessibility-fix')) {
                            heading.setAttribute('aria-hidden', 'true');
                            heading.setAttribute('data-accessibility-fix', '88b57996a39043bba6cde81a9aae88f8');
                            allFixed = false;
                        }
                    });
                } catch (e) {
                    console.error('Error accessing iframe content:', e);
                }
            });

            if (allFixed) {
                clearInterval(interval);
            }
        } catch (error) {
            console.error('Error in fixAccessibility_88b57996a39043bba6cde81a9aae88f8:', error);
            clearInterval(interval);
        }
    }, 1000);
}

// Call the function to initiate the fix
fixAccessibility_88b57996a39043bba6cde81a9aae88f8();

function fixAccessibility_c372420121fb4548a347ab9f4de07c1c() {
    const interval = setInterval(() => {
        try {
            // Check for the <h2> element with the class 'upcart-header-text'
            const headerElement = document.querySelector('h2.upcart-header-text');
            if (headerElement && !headerElement.closest('[role="region"]')) {
                const section = document.createElement('section');
                section.setAttribute('role', 'region');
                section.setAttribute('aria-label', 'Shopping Cart Header');
                section.setAttribute('data-accessibility-fix', 'c372420121fb4548a347ab9f4de07c1c');
                headerElement.parentNode.insertBefore(section, headerElement);
                section.appendChild(headerElement);
            }

            // Check for the <div> element with the class 'styles_CartPreview__empty__WFP86'
            const cartPreviewElement = document.querySelector('.styles_CartPreview__empty__WFP86');
            if (cartPreviewElement && !cartPreviewElement.closest('[role="region"]')) {
                const section = document.createElement('section');
                section.setAttribute('role', 'region');
                section.setAttribute('aria-label', 'Cart Status');
                section.setAttribute('data-accessibility-fix', 'c372420121fb4548a347ab9f4de07c1c');
                cartPreviewElement.parentNode.insertBefore(section, cartPreviewElement);
                section.appendChild(cartPreviewElement);
            }

            // Check if all fixes are applied
            if (document.querySelectorAll('[data-accessibility-fix="c372420121fb4548a347ab9f4de07c1c"]').length >= 2) {
                clearInterval(interval);
            }
        } catch (error) {
            console.error('Error applying accessibility fixes:', error);
        }
    }, 1000);
}

fixAccessibility_c372420121fb4548a347ab9f4de07c1c();

function fixAccessibility_79fed6ba191c49f49c777a1f71fb1456() {
    const targets = [
        {
            selector: 'div#shopify-section-sections--17473440153766__migration-header',
            role: 'banner'
        },
        {
            selector: 'div#shop-hcaptcha-badge-container',
            role: 'complementary'
        },
        {
            selector: 'div#shopify-section-sections--17473440153766__announcement_bar_8FUH6d',
            role: 'complementary'
        }
    ];

    const interval = setInterval(() => {
        let allFixed = true;

        targets.forEach(target => {
            const element = document.querySelector(target.selector);
            if (element && !element.hasAttribute('data-accessibility-fix')) {
                element.setAttribute('role', target.role);
                element.setAttribute('data-accessibility-fix', '79fed6ba191c49f49c777a1f71fb1456');
                console.log(`Accessibility fix applied to ${target.selector}`);
            }
            if (!element) {
                allFixed = false;
            }
        });

        if (allFixed) {
            clearInterval(interval);
            console.log('All accessibility fixes applied.');
        }
    }, 1000);
}

fixAccessibility_79fed6ba191c49f49c777a1f71fb1456();

function fixAccessibility_6bd70e4062e74112ae1d79334e46b464() {
    const interval = setInterval(() => {
        try {
            const element = document.querySelector('#shopify-section-sections--17473440153766__announcement_bar_8FUH6d');
            if (element && element.getAttribute('role') === 'complementary' && !element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby') && !element.hasAttribute('title')) {
                element.setAttribute('aria-label', 'Announcement Bar');
                element.setAttribute('data-accessibility-fix', '6bd70e4062e74112ae1d79334e46b464');
                clearInterval(interval);
            }
        } catch (error) {
            console.error('Error applying accessibility fix:', error);
        }
    }, 1000);
}

fixAccessibility_6bd70e4062e74112ae1d79334e46b464();

function fixAccessibility_ea920ea66724493283316b38d15ef90f() {
    const intervalId = setInterval(() => {
        try {
            // Select the element
            const cartPopup = document.querySelector('#CartPopup');
            
            // Check if the element exists and has the accessibility violation
            if (cartPopup && cartPopup.getAttribute('data-scrollable') === 'true' && !cartPopup.hasAttribute('tabindex')) {
                // Make the element focusable by adding tabindex="0"
                cartPopup.setAttribute('tabindex', '0');
                
                // Add a descriptor attribute for identification
                cartPopup.setAttribute('data-accessibility-fix', 'ea920ea66724493283316b38d15ef90f');

                // Clear the interval since the fix has been applied
                clearInterval(intervalId);
            }
        } catch (error) {
            console.error('Error applying accessibility fix:', error);
        }
    }, 1000);
}

fixAccessibility_ea920ea66724493283316b38d15ef90f();